import React, { lazy, Suspense } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
  },
}));

const Index = (props) => {
  const classes = useStyles();

  return <Paper className={classes.paper}>{props.children}</Paper>;
};

export default Index;
